export default `
Administratorem Państwa danych osobowych jest Dawid Radziemski "DevilAuto" z siedzibą ul. Rakowiecka 70,50422 Wrocław,
NIP: 9880241372,
REGON: 021128790,
zwany dalej Administratorem.
Jeśli mają Państwo jakiekolwiek pytania dotyczące sposobu i zakresu przetwarzania Państwa danych osobowych,
a także przysługujących Państwu uprawnień, mogą Państwo kontaktować się z Administratorem za pośrednictwem
adresu e-mail: dawid.radziemski@wp.pl, telefonicznie pod numerem +48 603 135 505 lub listownie
na adres Administratora: Dawid Radziemski "DevilAuto" ul. Rakowiecka 70,50422 Wrocław.`
